// extracted by mini-css-extract-plugin
module.exports = {"langSelect":"LaguageSelector_langSelect___mrUm"};